import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, CardActionArea, Link, Tooltip } from '@material-ui/core';
import Popover from '@material-ui/core/Popover';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import Divider from '@material-ui/core/Divider';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import InfoIcon from '@material-ui/icons/InfoOutlined';

export interface ContextMenuLinks {
	to: string | boolean; title: string; onClick?: () => void; icon: () => {}; show?: boolean;
}

export interface ContextMenuProps {
	links: ContextMenuLinks[];
	show?: boolean;
}

function ContextMenu(props: ContextMenuProps): JSX.Element {
	const navigate = useNavigate();

	const [anchorEl, setAnchorEl] = React.useState(null);
	const handleClose = (): void => {
		setAnchorEl(null);
	};
	const handleClick = (event): void => {
		setAnchorEl(event.currentTarget);
	};
	const open = Boolean(anchorEl);
	const id: string | undefined = open ? 'simple-popover' : undefined;

	const handleNavigateOrClick = (linkDetail): void => {
		if (linkDetail.to) {
			if (linkDetail.newTab) {
				window.open(linkDetail.to);
			} else {
				navigate(linkDetail.to);
			}
		}

		if (linkDetail.onClick) {
			linkDetail.onClick();
		}
	};
	return (
		props.links?.find(m => m.show === true) ? <>
			<ClickAwayListener onClickAway={handleClose}>
				<MoreVertIcon onClick={handleClick} style={{ cursor: 'pointer' }} />
			</ClickAwayListener>
			<Popover
				id={id}
				open={open}
				anchorEl={anchorEl}
				onClose={handleClose}
				anchorOrigin={{
					vertical: 'bottom',
					horizontal: 'right',
				}}
				transformOrigin={{
					vertical: 'top',
					horizontal: 'right',
				}}
			>
				{props.links.filter(m => m.show === true).map((link, linkKey) => {
					return (
						<React.Fragment key={linkKey}>
							<CardActionArea>
								<Link
									key={linkKey}
									onClick={() => handleNavigateOrClick(link)}
									style={{ textDecoration: 'none', cursor: 'pointer' }}
								>
									<Box style={{ padding: 10, fontWeight: 'bold', display: 'flex', alignItems: 'center', fontSize: 14, fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif' }}>
										{link.icon ? link.icon() : ''}
										<Box component="span" style={{ marginLeft: 5 }}>{link.title}</Box>
									</Box>
								</Link>
							</CardActionArea>
							{props.links.length > (linkKey + 1) ? < Divider /> : ''}
						</React.Fragment>
					);
				})}
			</Popover>
		</> : <Tooltip arrow title="No Actions Available">
			<InfoIcon />
		</Tooltip>);
}
export default ContextMenu;